import axiosClient from './axiosClient';

export const getListImage = (id?: any): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/images?${id}`;
    return axiosClient.get(url);
};